export default __webpack_public_path__ + "static/media/alert-red.05b0dafd.svg";